import React from 'react';
import { Box, Typography } from '@mui/material';
import { tint } from '../theme/accents';

// Shown in place of a table's rows when there are none. A bare "No rows" in the
// middle of 600px of empty space reads as a page that failed to load, so this
// says what the table holds and what to do to fill it.
const EmptyState = ({ icon, title, description, action, accent }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: 1,
      px: 3,
      py: 6,
      height: '100%',
    }}
  >
    {icon && (
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          width: 52,
          height: 52,
          mb: 0.5,
          borderRadius: '50%',
          color: accent,
          bgcolor: tint(accent, 0.14),
          border: '1px solid',
          borderColor: tint(accent, 0.3),
          '& .MuiSvgIcon-root': { fontSize: 26 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380 }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 1.5 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
